import { z } from "zod";
export const ForgeRelationType = z.enum(["Feature", "Document"]);
export const ForgeRelation = z.object({
    id: z.string(),
    projectId: z.string(),
    sourceItemId: z.string().uuid(),
    sourceItemType: ForgeRelationType,
    targetItemId: z.string().uuid(),
    targetItemType: ForgeRelationType,
    createdAt: z.string(),
});
